// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import RotateLeftOutlinedSvg from "@ant-design/icons-svg/lib/asn/RotateLeftOutlined";
import AntdIcon from "../components/AntdIcon";
const RotateLeftOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: RotateLeftOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    RotateLeftOutlined.displayName = "RotateLeftOutlined";
}
export default /*#__PURE__*/ React.forwardRef(RotateLeftOutlined);
